import { render, staticRenderFns } from "./FileChart.vue?vue&type=template&id=012d0a39"
import script from "./FileChart.vue?vue&type=script&lang=js"
export * from "./FileChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports